import React from 'react'
import { Updater, Widget, any, async, fromJSX } from 'widgets-for-react'
import { ComponentDidUpdate } from '../../../utils/lifecycleMethods'
import { CurrentPage } from '../../../utils/routes'
import { isDifferentPage } from '../routes/routesUtils'
import { Pages } from '../routes/routesState'
import {
  MetadataState,
  MetadataStateUpdaters,
  initialMetadataState,
  loadStaticMetadata,
} from './metadata.state'

export const metadataWidget = (
  s: MetadataState,
  page: CurrentPage<Pages>
): Widget<Updater<MetadataState>> =>
  any([
    async(loadStaticMetadata(s.data)).map(MetadataStateUpdaters.data),
    fromJSX((setState) => (
      <ComponentDidUpdate
        value={page}
        onUpdate={(oldPage, newPage) => {
          if (isDifferentPage(oldPage, newPage)) {
            setState(() => initialMetadataState)
          }
        }}
      />
    )),
  ])
